export default {
    updateSessions: (eventId, sessions, fetchTime) => ({type: 'VOTING_UPDATE_SESSIONS', eventId, sessions, fetchTime}),
};
